const myBookingsEN = {
	upcomingTitle: "Upcoming",
	upcomingSubLoading: "Loading...",
	upcomingSubCount: (count) => `${count} confirmed`,
	noUpcoming: "No upcoming bookings",
	emailSent: "Email sent",
	addToCalendar: "Add to Calendar",
	reschedule: "Reschedule",
	cancel: "Cancel",

	historyTitle: "History",
	historySub: "Your past visits",
	noHistory: "No past visits yet",

	table: {
		date: "Date",
		service: "Service",
		shop: "Shop",
		status: "Status",
	},
};

export default myBookingsEN;
